import { API_URL, postAnalytics } from "./api";

const SESSION_KEY = "conference.analyticsSession";
const VISITOR_KEY = "conference.analyticsVisitor";
const ACTIVE_TIME_CAP_MS = 12 * 60 * 60 * 1_000;

export function createActiveTimeTracker() {
  let accumulatedMs = 0;
  let activeSince: number | null = document.visibilityState === "visible" && document.hasFocus() ? Date.now() : null;
  const isActive = () => document.visibilityState === "visible" && document.hasFocus();
  const pause = () => {
    if (activeSince === null) return;
    accumulatedMs = Math.min(ACTIVE_TIME_CAP_MS, accumulatedMs + Math.max(0, Date.now() - activeSince));
    activeSince = null;
  };
  const resume = () => { if (activeSince === null && isActive()) activeSince = Date.now(); };
  const onVisibility = () => (isActive() ? resume() : pause());
  document.addEventListener("visibilitychange", onVisibility);
  window.addEventListener("focus", resume);
  window.addEventListener("blur", pause);
  return {
    getDurationMs() {
      if (activeSince !== null) return Math.min(ACTIVE_TIME_CAP_MS, accumulatedMs + Math.max(0, Date.now() - activeSince));
      return accumulatedMs;
    },
    dispose() {
      pause();
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("focus", resume);
      window.removeEventListener("blur", pause);
    },
  };
}

export function getAnalyticsSessionId() {
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

export function getAnalyticsVisitorId() {
  let visitorId = localStorage.getItem(VISITOR_KEY);
  if (!visitorId) {
    visitorId = crypto.randomUUID();
    localStorage.setItem(VISITOR_KEY, visitorId);
  }
  return visitorId;
}

export function trackAnalytics(event: "page_open" | "form_started" | "page_leave", durationMs?: number) {
  return postAnalytics({ event, sessionId: getAnalyticsSessionId(), visitorId: getAnalyticsVisitorId(), durationMs });
}

export function sendLeaveBeacon(durationMs: number) {
  const body = JSON.stringify({
    event: "page_leave",
    sessionId: getAnalyticsSessionId(),
    visitorId: getAnalyticsVisitorId(),
    durationMs: Math.max(0, Math.round(durationMs)),
  });
  navigator.sendBeacon(`${API_URL}/api/analytics`, body);
}
